export default __webpack_public_path__ + "static/fourth_background_mobile-e40ad52b0a6e9a6b079bc33d0dd56265.svg";